module.exports = __webpack_public_path__ + "img/flyer_09.66c3eaf5.jpeg";